import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NumberedListItem } from 'base-ui'

export const ProductPageOdsDialogOnlineDoctorSectionSteps: FC = () => (
  <section id="ods-steps">
    <h3 className="mb-5 font-medium">
      <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.stepsHeader" />
    </h3>
    <ol className="flex flex-col gap-5">
      <NumberedListItem>
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.process.step1" />
      </NumberedListItem>
      <NumberedListItem>
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.process.step2" />
      </NumberedListItem>
      <NumberedListItem>
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.process.step3" />
      </NumberedListItem>
    </ol>
  </section>
)
